import React from 'react';
import { useStyles } from './styles';
import { Button, useTheme } from '@material-ui/core';
import { useEditFormContext } from '../context';
import { PreviewButton } from './PreviewButton';
import { IRouterProps } from 'pages/orderHistory';
import { DiscartChangesButton } from './DiscartChangesButtons';

export const PageFooter = ({ router }: IRouterProps) => {
  const { handleSubmitForm, isSubmitingForm } = useEditFormContext();
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <div className={styles.footer}>
      <DiscartChangesButton />
      <PreviewButton router={router} />
      <Button
        className={styles.button}
        onClick={handleSubmitForm}
        disabled={isSubmitingForm}
        variant="contained"
        color="secondary"
      >
        Salvar
      </Button>
    </div>
  );
};
